/**
 * Tab Item
 */
export class TabItem {
    /**
     * Constructor
     * @param button button
     * @param content content
     * @param listener listener
     */
    constructor(button, content, listener) {
        this.button = button;
        this.content = content;
        this.listener = listener;
        // default style
        button.style.cursor = 'pointer';
        // add listener
        let _this = this;
        button.addEventListener('click', () => {
            _this.tabFolder.setActive(_this.tabIndex);
        });
        // set de-active
        this.setActive(false);
    }
    /**
     * Sets tab folder
     * @param tabFolder tab folder
     */
    setTabFolder(tabFolder) {
        this.tabFolder = tabFolder;
    }
    /**
     * Sets tab index
     * @param tabIndex tab index
     */
    setTabIndex(tabIndex) {
        this.tabIndex = tabIndex;
    }
    /**
     * Sets active
     * @param active active or not
     */
    setActive(active) {
        if (active) {
            this.button.style.opacity = 'unset';
            this.content.removeAttribute('hidden');
            this.listener.call(this);
        }
        else {
            this.button.style.opacity = '0.5';
            this.content.setAttribute('hidden', String(true));
        }
    }
}
//# sourceMappingURL=TabItem.js.map